<template>
  <b-container class="py-4 py-md-5 px-3 px-md-0 animate-fade-in">
    <!-- KHỐI 1: HEADER & LIÊN HỆ -->
    <header class="mb-4 mb-md-5 border-bottom pb-4">
      <!-- Avatar -->
      <div class="avatar-wrapper mx-auto">
        <img
          :src="require('@/assets/avatar-hau.jpg')"
          alt="Avatar"
          class="avatar-img shadow-sm border border-vue"
        />
      </div>

      <b-col cols="12" md="9" class="text-left mb-4 mb-md-0">
        <h1 class="h2 text-vue-dark font-weight-bold mb-1 responsive-title">
          PHẠM VĂN HẬU
        </h1>
        <h2
          class="h5 text-vue-green font-weight-normal mb-3 responsive-subtitle"
        >
          Senior Fullstack Developer (Node.js & React)
        </h2>
        <p class="text-muted text-justify responsive-lead mb-0">
          Lập trình viên Full-stack phát triển sản phẩm, hệ thống nội bộ và
          chuyển đổi số (Zalo Mini App, chấm công, tích điểm, bán hàng). Thành
          thạo xây dựng ứng dụng web hiện đại với ReactJS/NextJS kết hợp Backend
          Node.js, RESTful APIs, xử lý dữ liệu và tích hợp hệ thống bên thứ ba
          (PA Invoice, VBee). Có năng lực tự thiết kế kiến trúc, cấu hình hạ
          tầng Docker/DevOps và vận hành các giải pháp tự động hóa tích hợp AI.
        </p>
      </b-col>

      <!-- Hàng chứa thông tin liên hệ phụ bên dưới -->
      <b-row class="mt-4">
        <b-col cols="12">
          <div
            class="p-3 bg-white shadow-sm rounded border border-vue d-flex flex-column flex-md-row justify-content-between align-items-center gap-3"
          >
            <div
              class="text-vue-dark font-weight-bold mb-1 mb-md-0 small text-uppercase flex-shrink-0"
            >
              📇 Liên hệ:
            </div>
            <div class="text-truncate mb-1 mb-md-0">
              📧
              <a
                href="mailto:hauphvn@gmail.com"
                class="text-vue-dark font-weight-bold"
                >hauphvn@gmail.com</a
              >
            </div>
            <div class="mb-1 mb-md-0 flex-shrink-0">
              📱
              <a href="tel:+84967900801" class="text-vue-dark font-weight-bold"
                >+84 967 90 0801</a
              >
            </div>
            <div class="mb-1 mb-md-0 flex-shrink-0">
              🐱
              <a
                href="https://github.com/hauphvn"
                target="_blank"
                class="text-vue-dark font-weight-bold"
                >github.com/hauphvn</a
              >
            </div>
            <div class="mb-1 mb-md-0 text-center text-md-left small-content">
              📍
              <span class="text-vue-dark font-weight-bold"
                >944 Huỳnh Tấn Phát, Phú Thuận, Quận 7, HCM</span
              >
            </div>
          </div>
        </b-col>
      </b-row>
    </header>

    <section class="mb-4 mb-md-5">
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">🛠️ Kỹ Thuật</h4>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-3"
          v-for="(tech, index) in techMatrix"
          :key="index"
        >
          <b-card class="h-100 shadow-sm border-0 bg-white card-custom">
            <h5
              class="card-title font-weight-bold text-vue-green small-title mb-2"
            >
              {{ tech.title }}
            </h5>
            <p class="card-text text-dark font-weight-wide mb-0 small-content">
              {{ tech.items }}
            </p>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <section class="mb-4 mb-md-5">
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">
        💼 Kinh Nghiệm Làm Việc
      </h4>
      <b-list-group class="shadow-sm border-0">
        <b-list-group-item
          class="p-3 p-md-4 border-0 mb-3 bg-white rounded card-custom"
          v-for="exp in experience"
          :key="exp.company"
        >
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2"
          >
            <h5 class="font-weight-bold text-vue-dark mb-2 mb-md-0 small-title">
              {{ exp.role }} — {{ exp.company }}
            </h5>
            <b-badge class="px-3 py-1 badge-vue-light mb-2 mb-md-0"
              >{{ exp.period }}
            </b-badge>
          </div>
          <p class="text-muted small text-justify mb-0" v-html="exp.desc"></p>
        </b-list-group-item>
      </b-list-group>
    </section>

    <section class="mb-4 mb-md-5">
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">
        🚀 Hệ Thống Sản Phẩm Đã Triển Khai
      </h4>
      <b-row>
        <!-- KHỐI POS & ELECTRON & TẢI VỀ -->
        <b-col cols="12" class="mb-4">
          <b-card class="shadow-sm border-0 p-2 p-md-3 bg-vue-dark text-white">
            <b-row align-v="center">
              <b-col cols="12" lg="8" class="mb-3 mb-lg-0">
                <h5 class="font-weight-bold text-warning mb-2 small-title">
                  Hệ thống POS & Ứng dụng Desktop POS (ElectronJS)
                </h5>
                <p class="small text-light-80 text-justify mb-3">
                  Xây dựng ứng dụng desktop POS bán hàng bằng ElectronJS chạy
                  tại cửa hàng. Tích hợp tính năng Silent Print (In ngầm K80)
                  đẩy cấu trúc hóa đơn trực tiếp ra driver in nhiệt không qua
                  hộp thoại hệ thống. Bảo mật mã hóa Token lưu trữ an toàn. Tự
                  động cập nhật đè siêu tốc tại quầy bán.
                </p>
                <div class="d-flex flex-column flex-sm-row gap-2">
                  <b-button
                    variant="light"
                    class="mb-2 mb-sm-0 font-weight-bold text-vue-dark py-2 py-md-1 mr-sm-2"
                  >
                    <a
                      class="text-vue-dark text-decoration-none"
                      href="https://pos.kaykafe.com/KayKafePOS%20Setup%203.0.2.exe"
                      download=""
                      >📥 Tải Bản Windows (.exe)</a
                    >
                  </b-button>
                  <b-button
                    variant="outline-light"
                    class="font-weight-bold py-2 py-md-1"
                  >
                    <a
                      class="text-decoration-none"
                      href="https://pos.kaykafe.com/KayKafePOS-3.0.2-arm64.dmg"
                      download=""
                    >
                      📥 Tải Bản Mac (.dmg)
                    </a>
                  </b-button>
                </div>
              </b-col>

              <!-- Cột bên phải: Khu vực Demo Automation & AI -->
              <b-col
                cols="12"
                lg="4"
                class="text-lg-right text-center border-left-lg"
              >
                <div
                  class="p-2 rounded bg-dark-transparency text-left text-lg-right"
                >
                  <span
                    class="d-block font-weight-bold text-vue-green small mb-1"
                    >🤖 Automation & AI Platform</span
                  >
                  <p
                    class="text-light-80 small mb-3 text-justify text-lg-right line-height-sm"
                  >
                    Hệ thống tự động hóa quy trình vận hành chuỗi và tích hợp
                    AI. Demo xử lý luồng dữ liệu thông minh kết nối trực tiếp
                    với OpenAI Platform.
                  </p>
                  <b-button
                    href="https://automation-test-v1.kaykafe.com/"
                    target="_blank"
                    variant="success"
                    block
                    class="font-weight-bold btn-vue-green py-2"
                  >
                    ⚙️ Open n8n UI Sandbox
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <!-- CÁC DỰ ÁN WEB TIÊU BIỂU -->
        <b-col
          cols="12"
          sm="6"
          md="4"
          class="mb-3 mb-md-4"
          v-for="proj in webProjects"
          :key="proj.id"
        >
          <b-card no-body class="h-100 border-0 shadow-sm bg-white card-custom">
            <b-card-body class="p-3 p-md-4">
              <div
                class="d-flex justify-content-between align-items-start mb-2"
              >
                <h5 class="font-weight-bold text-vue-dark mb-0 small-title">
                  {{ proj.title }}
                </h5>
                <b-badge
                  v-if="proj.tag"
                  class="badge-vue-light text-uppercase"
                  style="font-size: 10px"
                  >{{ proj.tag }}
                </b-badge>
              </div>
              <p class="card-text text-muted small mb-0 text-justify">
                {{ proj.desc }}
              </p>
            </b-card-body>
            <b-card-footer
              class="bg-transparent border-0 pt-0 pb-3 pb-md-4 px-3 px-md-4"
            >
              <b-button
                :href="proj.url"
                target="_blank"
                variant="outline-vue"
                block
                class="btn-outline-vue py-2 py-md-1"
              >
                Truy cập ứng dụng
              </b-button>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <section>
      <h4 class="text-vue-dark font-weight-bold mb-3 mb-md-4">🎓 Học Vấn</h4>
      <b-card class="shadow-sm border-0 bg-white p-2 card-custom">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
        >
          <div class="mb-2 mb-md-0">
            <h5 class="font-weight-bold text-vue-dark mb-1 small-title">
              Trường Đại học Khoa học Tự nhiên TP.HCM
            </h5>
            <p class="text-muted mb-0 small">
              Chuyên ngành: Công nghệ Thông tin
            </p>
          </div>
          <b-badge class="badge-vue-light px-3 py-1">2015 - 2019</b-badge>
        </div>
      </b-card>
    </section>
  </b-container>
</template>

<script>
export default {
  name: "HauPhanProfile",
  data() {
    return {
      techMatrix: [
        {
          title: "FRONTEND & DESKTOP",
          items:
            "ReactJS, Angular, Next.js, ElectronJS, Tailwind CSS v4, Ant Design, JavaScript (ES6+), TypeScript",
        },
        {
          title: "BACKEND & API",
          items:
            "Node.js (Express/NestJS), RESTful API, Authentication & Authorization (JWT, OAuth, Firebase), Async/Await",
        },
        {
          title: "DATABASE & DATA",
          items:
            "PostgreSQL, MySQL, MongoDB, Redis Caching, Tối ưu hóa truy vấn dữ liệu",
        },
        {
          title: "HẠ TẦNG & DEVOPS",
          items:
            "Docker, Git, Linux, CI/CD Actions, Cloudflare R2, n8n Automation, Monitoring cơ bản",
        },
      ],
      experience: [
        {
          company: "Kaykafe",
          role: "Fullstack & DevOps Engineer",
          period: "2020 - 2026",
          desc: "<strong>Hệ thống:</strong> Chịu trách nhiệm thiết kế hạ tầng, thiết lập luồng CI/CD, tự động hóa quy trình vận hành chuỗi và trực tiếp triển khai môi trường Production/Staging.<br><strong>Frontend:</strong> Xây dựng website chuẩn SEO bằng Next.js cho khách hàng; website cho admin quản trị sản phẩm, nhân viên, khách hàng bằng React.<br><strong>Desktop App:</strong> Xây dựng ứng dụng desktop POS bán hàng bằng ElectronJS.<br><strong>Mobile & Zalo:</strong> Xây dựng ứng dụng Zalo Mini App và hệ thống gửi Zalo ZBS; web mobile cho nhân viên chấm công, kiểm kho bằng React.<br><strong>Backend:</strong> Xây dựng hệ thống API dùng cho toàn hệ thống bán hàng với <strong>Node.js</strong>, PostgreSQL, Redis, Firebase Authentication.",
        },
        {
          company: "PhucKhangNet",
          role: "Backend & Fullstack Developer",
          period: "2023 - 2026",
          desc: "Xây dựng kiến trúc hệ thống lõi (Core Logic), phát triển Web API bằng <strong>Node.js</strong> hiệu năng cao, tối ưu hóa câu lệnh truy vấn cơ sở dữ liệu MySQL/PostgreSQL và xử lý các bài toán tích hợp tự động hóa kết nối với API bên thứ ba. Vận hành toàn bộ hạ tầng hosting cho hệ thống server.",
        },
        {
          company: "CMC Global",
          role: "Frontend Developer",
          period: "2019 - 2023",
          desc: "Xây dựng UI cho khách hàng thị trường Nhật Bản sử dụng React, Angular, TailwindCSS, Ant Design.",
        },
      ],
      webProjects: [
        {
          id: 1,
          title: "KayKafe System",
          tag: "FullStack",
          desc: "Xây dựng hệ thống CRM, Point of Sale (POS), Web quản trị và tối ưu chuẩn SEO cho website bán hàng.",
          url: "https://kaykafe.com/",
        },
        {
          id: 2,
          title: "Ngoạn Thạch Việt",
          tag: "Backend",
          desc: "Xây dựng API, vận hành hosting server cho Web/App và phát triển ứng dụng Zalo Mini App.",
          url: "https://ngoanthachviet.com/",
        },
        {
          id: 3,
          title: "Tax Invoice Portal",
          tag: "Portal",
          desc: "Cổng tự động hóa dịch vụ: Cho phép người dùng quét mã truy xuất dữ liệu và xử lý chứng từ trực tuyến trong ngày.",
          url: "https://xuathoadon.kaykafe.com",
        },
        {
          id: 4,
          title: "Intage Platform",
          tag: "Frontend",
          desc: "Hệ thống ghi nhận, trích xuất dữ liệu video từ AI. Xây dựng UI theo thiết kế Figma sử dụng AngularJS.",
          url: "https://profile.detoixem.io.vn",
        },
        {
          id: 5,
          title: "IIS File Management",
          tag: "Frontend",
          desc: "Hệ thống quản trị tài liệu doanh nghiệp sử dụng React TypeScript, Tailwind CSS và Redux.",
          url: "https://profile.detoixem.io.vn",
        },
      ],
    };
  },
};
</script>

<style scoped>
.text-vue-green {
  color: #42b883 !important;
}

.text-vue-dark {
  color: #35495e !important;
}

.bg-vue-dark {
  background-color: #35495e !important;
}

.border-vue {
  border-color: rgba(66, 184, 131, 0.25) !important;
}

.card-custom {
  border-left: 4px solid #42b883 !important;
}

.badge-vue-light {
  background-color: rgba(66, 184, 131, 0.1) !important;
  color: #42b883 !important;
  font-weight: 600;
}

.btn-vue-dark {
  background-color: #35495e !important;
  border-color: #35495e !important;
  color: #fff !important;
}

.btn-vue-dark:hover {
  background-color: #2c3e50 !important;
}

.btn-outline-vue {
  color: #42b883 !important;
  border-color: #42b883 !important;
}

.btn-outline-vue:hover {
  background-color: #42b883 !important;
  color: #fff !important;
}
.avatar-wrapper {
  width: 100%;
  max-width: 300px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 0;
}

@media (max-width: 576px) {
  .responsive-title {
    font-size: 1.85rem !important;
    text-align: center;
  }

  .responsive-subtitle {
    font-size: 1.1rem !important;
    text-align: center;
  }

  .responsive-lead {
    font-size: 0.95rem !important;
  }

  .small-title {
    font-size: 1.05rem !important;
  }

  .small-content {
    font-size: 0.9rem !important;
  }
}

.animate-fade-in {
  animation: fadeIn 0.4s ease-out;
}

.text-light-80 {
  color: rgba(255, 255, 255, 0.85);
}

.bg-dark-transparency {
  background-color: rgba(0, 0, 0, 0.2);
}

.line-height-sm {
  line-height: 1.35;
}

.btn-vue-green {
  background-color: #42b883 !important;
  border-color: #42b883 !important;
}

.btn-vue-green:hover {
  background-color: #3aa372 !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 992px) {
  .border-left-lg {
    border-left: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
}
</style>
